import React from 'react';
import { getAllStats } from '../../utils';

const STAT_CONFIG = [
  {
    key: 'temp1',
    title: 'Temperatura 1',
    unit: '°C',
    accent: 'var(--accent-orange)',
    accentBg: 'rgba(249, 115, 22, 0.12)',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z" />
      </svg>
    ),
  },
  {
    key: 'do1',
    title: 'Oxígeno Disuelto 1',
    unit: ' mg/L',
    decimals: 2,
    accent: 'var(--accent-cyan)',
    accentBg: 'rgba(6, 182, 212, 0.12)',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10" />
        <path d="M12 6v6l4 2" />
      </svg>
    ),
  },
  {
    key: 'do2',
    title: 'Oxígeno Disuelto 2',
    unit: ' mg/L',
    decimals: 2,
    accent: '#818cf8',
    accentBg: 'rgba(129, 140, 248, 0.12)',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10" />
        <path d="M12 6v6l4 2" />
      </svg>
    ),
  },
  {
    key: 'sat1',
    title: 'Saturación 1',
    unit: '%',
    accent: 'var(--accent-green)',
    accentBg: 'rgba(16, 185, 129, 0.12)',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
      </svg>
    ),
  },
];

const fmt = (val, decimals = 1) =>
  val === null || val === undefined ? '—' : Number(val).toFixed(decimals);

const StatCard = ({ config, statData }) => {
  const decimals = config.decimals ?? 1;
  const hasData = statData && statData.count > 0;

  return (
    <div className="stats-card-v2">
      <div className="stats-card-header" style={{ '--stat-accent': config.accent, '--stat-accent-bg': config.accentBg }}>
        <span className="stats-card-icon">{config.icon}</span>
        <div className="stats-card-meta">
          <div className="stats-card-title">{config.title}</div>
          {hasData && (
            <div className="stats-card-count">{statData.count} lecturas</div>
          )}
        </div>
      </div>

      <div className="stats-card-body">
        <div className="stats-pill stats-pill-min">
          <span className="stats-pill-label">MÍN</span>
          <span className="stats-pill-value">{fmt(statData?.min, decimals)}<span className="stats-pill-unit">{hasData ? config.unit : ''}</span></span>
        </div>
        <div className="stats-pill stats-pill-avg">
          <span className="stats-pill-label">PROM</span>
          <span className="stats-pill-value stats-pill-value-avg">{fmt(statData?.avg, decimals)}<span className="stats-pill-unit">{hasData ? config.unit : ''}</span></span>
        </div>
        <div className="stats-pill stats-pill-max">
          <span className="stats-pill-label">MÁX</span>
          <span className="stats-pill-value">{fmt(statData?.max, decimals)}<span className="stats-pill-unit">{hasData ? config.unit : ''}</span></span>
        </div>
      </div>
    </div>
  );
};

export const StatsSection = ({ history }) => {
  const stats = getAllStats(history);

  if (!stats) return null;

  return (
    <>
      <div className="section-title">
        <span className="section-icon">📊</span>
        <span className="section-title-text">
          Estadísticas
          <span className="section-title-detail"> (Últimas {history.length} lecturas)</span>
        </span>
      </div>
      <div className="stats-grid-v2 fade-in stagger-5">
        {STAT_CONFIG.map((cfg) => (
          <StatCard key={cfg.key} config={cfg} statData={stats[cfg.key]} />
        ))}
      </div>
    </>
  );
};
